export function formatCode(code: string): string {
  const parts = code.match(/.{1,3}/g);
  return parts?.join(' ') || code;
}
